import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VeriffService } from '@app/services/veriff.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ModalComponent } from '../../common/modal/modal.component';
import { catchError, of, switchMap, tap, timer } from 'rxjs';

@Component({
  selector: 'app-veriff-verification-waiting-dialog',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ModalComponent],
  templateUrl: './veriff-verification-waiting-dialog.component.html',
  styleUrl: './veriff-verification-waiting-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VeriffVerificationWaitingDialogComponent implements OnInit {
  protected readonly modalTitleKey = 'registrationWizard.veriffWaiting.title';
  protected readonly statusText = signal('');

  private readonly veriffService = inject(VeriffService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly translate = inject(TranslateService);

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    timer(0, 10_000)
      .pipe(
        switchMap(() =>
          this.veriffService.getStatus().pipe(
            catchError(() =>
              of({
                verified: false,
                status: this.translate.instant(
                  'registrationWizard.veriffWaiting.pollError',
                ),
              }),
            ),
          ),
        ),
        tap((r) => this.statusText.set(r.status)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((r) => {
        if (r.verified) {
          this.activeModal.close(true);
        }
      });
  }
}
